import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.css'],
  providers: [NgbModal],
})
export class FormDialogComponent implements OnInit {

  constructor(private ms: NgbModal) {}

  form = new FormGroup({});

  @Input() title: string | undefined;
  @Input() model: any = {};
  @Input() options: FormlyFormOptions = {};
  @Input() fields: FormlyFieldConfig[] = [{
    "key": "email" ,
    "type": "input" ,
    "props": {
      "type": "email" ,
      "label": "E-mail" ,
      "placeholder": "Insert a valid e-mail" ,
      "minLength": 3
    }
  }];

  closeResult: string = "";

  ngOnInit() {}

  open(content: any) {
    this.ms.open(content, {
      centered: true,
      ariaLabelledBy: 'modal-basic-title'
    }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dism with: ${reason}`;
      });
  }
}
